export const theme = {
  fontSize: {
    xSmall: "14px",
    small: "16px",
    normal: "18px",
    medium: "20px",
    large: "22px",
    xlarge: "24px",
    xxlarge: "36px",
    xxxLarge: "64px",
  },
  color: {
    black: "000000",
    dark: "#020001",
    yellow: "#e8e012",
    light: "FFFFFF",
  },
  media: {
    extraMobileSmall: "340px",
    extraMobile: "575.98px",
    mobile: "767.98px",
    tablet: "991.98px",
    desktop: "1199.98px",
  },
};
